import SEO from "@/components/site/SEO";
import PageHeader from "@/components/site/PageHeader";
import FAQSection from "@/components/site/FAQSection";
import QuoteCTA from "@/components/site/QuoteCTA";
import { FAQS } from "@/lib/faqs";

export default function FAQ() {
  // FAQPage schema for Google rich snippets
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <div data-testid="faq-page">
      <SEO
        title="FAQ — Parking Lot Striping & Sealcoating Questions"
        description="Common questions about parking lot striping, sealcoating, ADA compliance, restriping, and pavement marking — answered by the 901 Lots crew."
        path="/faq"
        jsonLd={faqSchema}
      />

      <PageHeader
        eyebrow="FAQ"
        title="Answers before you call."
        subtitle="The questions Mid-South property managers ask us every week — covering striping, sealcoating, ADA compliance, scheduling, materials, and pricing."
      />

      <FAQSection
        title="Everything you might want to know"
        eyebrow="All questions"
        subtitle="Click any question to expand the answer. Still unsure? Send us a note through the free quote form — we'll reply within a day."
      />

      <QuoteCTA />
    </div>
  );
}
